import WorkOrderCreate from './WorkOrderCreate';

export default WorkOrderCreate;
